$(function () {
  'use strict';
  var buildTierTable = function (data, singleprice, tblHeaders, lblContact, urlContact) {

    var strHtmlTable = '<table align="center" cellpadding="0" cellspacing="0" ><tbody>';
    var rowBegin = '<tr>';
    var colRight = '<td align="right" style="height: 25px;">';
    var colmid = '<td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>';
    var colLeft = '<td align="left">';
    var colEnd = '</td>';
    var rowEnd = '</tr>';

    if (tblHeaders) {
      var headers = tblHeaders.split(',');
      if (headers.length > 1) {
        var headerColRight = colRight + '<strong>' + headers[0] + '</strong>' + colEnd;
        var headerColLeft = colLeft + '<strong>' + headers[1] + '</strong>' + colEnd;
        strHtmlTable += rowBegin + headerColRight + colmid + headerColLeft + rowEnd;
      }
    }

    var tierList = data.discountsList;
    $.each(tierList, function (i, item) {
      var itemColRight = colRight + item.min + '&nbsp;-&nbsp;' + item.max + colEnd;
      var itemColLeft = colLeft + item.unitPrice + colEnd;
      if (i === 0) {
        itemColLeft = colLeft + singleprice + colEnd;
      }
      strHtmlTable += rowBegin + itemColRight + colmid + itemColLeft + rowEnd;
    });

    if (lblContact && urlContact && tierList.length > 0) {
      var contactMax = tierList[tierList.length - 1].max + 1;
      var itemColRight = colRight + contactMax + '&nbsp;+&nbsp;' + colEnd;
      var itemColLeft = colLeft + '<a href="' + urlContact + '" >' + lblContact + '</a>' + colEnd;
      strHtmlTable += rowBegin + itemColRight + colmid + itemColLeft + rowEnd;
    }

    strHtmlTable += '</tbody></table>';
    return strHtmlTable;
  };

  var productRequest = function (selection, requestType) {

    var baseUrl = '/store/local/pricing';
    var product = selection.data('product');

    // Exit if falsey or missing a dash (bad PID)
    if (!product || product.indexOf('-') < 0) {
      return false;
    }

    var productSingle = requestType === 'combo' ? product : product.replace('-multi', '-single');
    var productMulti = product.replace('-single', '-multi');

    var products = [productSingle];
    if (requestType === 'multi') {
      products.push(productMulti);
    }

    var requestUrl = baseUrl + '?products=' + products.join(',') + window.location.search.replace('?', '&');
    var ajaxRequest = $.ajax({
      type: 'GET',
      url: requestUrl,
      contentType: 'text/plain',
      xhrFields: {
        withCredentials: false
      },
    });

    return {
      ajax: ajaxRequest,
      multi: productMulti,
      single: productSingle
    };
  };

  $('.local-price').each(function () {
    var $selection = $(this);
    var requests = productRequest($selection, 'single');

    if (!requests) {
      $selection.removeClass('invisible');
      return;
    }

    requests.ajax.done(function (a) {
      var item = a.productsList[0];
      var postfix = $selection.data('postfix') || '';

      var htmlContent = '<div class="pricing-container">';
      if (item.priceValue > item.unitPriceValue) {
        htmlContent += '<div class="original-price" >' + item.price + postfix + '</div>';
      }

      htmlContent += '<div>' + item.unitPrice + postfix + '</div></div>';
      $selection.html(htmlContent);
      $selection.removeClass('invisible');

    }).fail(function () {
      $selection.removeClass('invisible');
    });
  });

  $('.local-price-tier').each(function () {
    var $selection = $(this);
    var requests = productRequest($selection, 'multi');

    if (!requests) {
      $selection.removeClass('invisible');
      return;
    }

    requests.ajax.done(function (data) {
      var itemSingle = data.productsList.filter(function (obj) {
        return obj.pid === requests.single;
      })[0];

      var itemMulti = data.productsList.filter(function (obj) {
        return obj.pid === requests.multi;
      })[0];

      if (itemSingle && itemMulti) {
        var tblHeaders = $selection.data('header');
        var lblContact = $selection.data('contactlbl');
        var urlContact = $selection.data('contacturl');

        $selection.html(buildTierTable(itemMulti, itemSingle.unitPrice, tblHeaders, lblContact, urlContact));
      } else {
        $selection.removeClass('invisible');
      }

    }).fail(function () {
      $selection.removeClass('invisible');
    });
  });

  $('.local-product-title').each(function () {
    var $selection = $(this);
    var product = $selection.data('product').split(',')[0];
    var requests = productRequest($selection, 'single');

    if (!requests) {
      $selection.removeClass('invisible');
      return;
    }

    requests.ajax.done(function (data) {
      var item = data.productsList.filter(function (obj) {
        return obj.pid === product;
      })[0];

      $selection.html(item.title);
    }).fail(function () {
      $selection.removeClass('invisible');
    });
  });

  $('.local-price-combo').each(function () {
    var $selection = $(this);
    var requests = productRequest($selection, 'combo');

    if (!requests) {
      $selection.removeClass('invisible');
      return;
    }

    requests.ajax.done(function (data) {
      var postfix = $selection.data('postfix') || '';
      var htmlContent = '<div class="pricing-container">';

      if (data.cartPriceValue > data.cartTotalValue) {
        htmlContent += '<div class="original-price" >' + data.cartPrice + postfix + '</div>';
      }
      htmlContent += '<div>' + data.cartTotal + postfix + '</div></div>';

      $selection.html(htmlContent);
      $selection.removeClass('invisible');
    }).fail(function () {
      $selection.removeClass('invisible');
    });
  });
});
